import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS, QueryDefaults } from 'api';
import { getAdminUsers } from '../methods';
import { GetAdminUsersResponse } from '../types';

export const useGetAdminUsers = (): QueryObserverResult<GetAdminUsersResponse> =>
  useQuery([API_QUERY_KEYS.getTQAdmins], getAdminUsers, QueryDefaults);
